var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJurisdiction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20.5px",
    height: "20px",
    viewBox: "0 0 20.5 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Jurisdiction") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-designs-current",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TP_PBA-InitialS-Serv",
    transform: "translate(-1451.000000, -820.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CompSearch-Menu---v1",
    transform: "translate(1415.000000, 647.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "travel_explore_black_24dp",
    transform: "translate(34.000000, 171.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3,16.9 C19.7,16.2 20,15.4 20,14.5 C20,12 18,10 15.5,10 C13,10 11,12 11,14.5 C11,17 13,19 15.5,19 C16.4,19 17.2,18.7 17.9,18.3 L21.1,21.5 L22.5,20.1 L19.3,16.9 Z M15.5,17 C14.1,17 13,15.9 13,14.5 C13,13.1 14.1,12 15.5,12 C16.9,12 18,13.1 18,14.5 C18,15.9 16.9,17 15.5,17 Z M12,20 L12,22 C6.48,22 2,17.52 2,12 C2,6.48 6.48,2 12,2 C16.84,2 20.87,5.44 21.8,10 L19.73,10 C19.09,7.54 17.33,5.53 15,4.59 L15,5 C15,6.1 14.1,7 13,7 L11,7 L11,9 C11,9.55 10.55,10 10,10 L8,10 L8,12 L10,12 L10,15 L9,15 L4.21,10.21 C4.08,10.79 4,11.38 4,12 C4,16.41 7.59,20 12,20 Z",
    id: "Shape",
    fill: "currentColor"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJurisdiction);
export default __webpack_public_path__ + "static/media/Jurisdiction.1c4a1f78.svg";
export { ForwardRef as ReactComponent };